<template>
    <div dir="ltr">
        <router-view name="navbar"></router-view>
        <router-view></router-view>
    </div>
</template>
<script>
export default {
  name: 'Index',
  mounted: function () {
    document.body.classList.remove('rtl')
  }
}
</script>